<div class="background-white">

  <div *ngIf="isloader">
    <div class="loader animation-start">
      <span class="circle delay-1 size-2"></span>
      <span class="circle delay-2 size-4"></span>
      <span class="circle delay-3 size-6"></span>
      <span class="circle delay-4 size-7"></span>
      <span class="circle delay-5 size-7"></span>
      <span class="circle delay-6 size-6"></span>
      <span class="circle delay-7 size-4"></span>
      <span class="circle delay-8 size-2"></span>
    </div>
  </div>
  {{isminiDrawerData()}}
  <div class="row" *ngIf="!isloader">
    <div class="col-md-12 ">
      <i class="fa fa-times-circle pull-right " style="color:#2E58D6 " (click)="closeBuyerProfileDrawer()"></i>
      <div class="mainheading" *ngIf="isPremium()">{{ iContactViewModel?.firstName + ' ' + iContactViewModel?.lastName}}
      </div>
    </div>
    <div class="col-md-12 ">
      <div class="rfq-star">
        <span
          style="color:#212A37; margin-right: 5px;">{{ (iContactViewModel.noOfStars)? (iContactViewModel.noOfStars | number : '1.0-1'): 'n/a'}}</span>
        <ng-template #t let-fill="fill">
          <span class="star" [class.full]="fill === 100">
            <span class="fill-star" [style.width.%]="fill">&#9733;</span>&#9733;
          </span>
        </ng-template>
        <ngb-rating [(rate)]="iContactViewModel.noOfStars" [starTemplate]="t" [readonly]="true" max="5"></ngb-rating>
      </div>
      <div class="title-blue" style="cursor: pointer; font-size: 14px; margin-bottom: 10px" (click)="readMore(iContactViewModel.companyId);" *ngIf="showViewFullProfileSideDrawer">
        <strong> View Full Profile</strong>
      </div>

      <div class="row col-sm-12 col-md-12 col-xl-12 buyer-rfq-count-container">
        <app-rfq-count-viewer [buyerID]=currentContactId [showOpenRfqsSideDrawer]="showOpenRfqsSideDrawer" ></app-rfq-count-viewer>
      </div>

      <div class="row m-t-10" *ngIf="isPremium()">
        <div class="col-md-12">
          <!-- [disabled]="!isAddratingDisabled" -->
          <button class="small-button btn" type="button" [disabled]="!isAddratingDisabled" (click)="showRatingModel()">
            Add your rating
          </button>

        </div>
      </div>
      <div class="row m-t-10" *ngIf="isPremium()">
        <div class="col-md-6">
          <!-- !iAboutUsModel.isFollowing -->
          <button *ngIf="!iAboutUsModel.isFollowing && showFollowunFollowBtnSideDrawer" class="small-button btn" type="button"
            (click)="setFollow(iAboutUsModel.companyId)">
            Follow Buyer
          </button>
          <button *ngIf="iAboutUsModel.isFollowing && showFollowunFollowBtnSideDrawer" class="small-button btn" type="button"
            (click)="unFollow(iAboutUsModel.companyId)">
            Unfollow Buyer
          </button>
        </div>
        <div class="col-md-6" *ngIf="isPremium()">
          <button class="small-button btn" type="button"
            (click)="openFeedbackModel(iAboutUsModel.name, iContactViewModel.companyId)">
            Buyer Feedback
          </button>
        </div>

      </div>
      <div class="block_border"></div>
    </div>

    <div class="col-md-12 rightpanel">

      <div class="row">
        <div class="col-md-3">
          <img *ngIf="isPremium()" class="contact_logo img-circle" [src]="contactlogo" alt="contact Logo"
            onError="this.src='assets/company/avatar-manu-basic-circle.svg'" style="border: 1px solid #bec4cb;" />
        </div>
        <div class="col-md-9">
          <div class="title-green" *ngIf="isPremium()">
            <div class="mainheading" style="color: #000000; margin-bottom: 8px"> {{iContactViewModel?.company?.name}}
            </div>
            <strong>MFG.com Member Since:</strong><br />{{ iAboutUsModel?.createdDate | date: "MM/dd/yyyy" }}
          </div>
        </div>
      </div>

      <div class="msg_block" *ngIf="isPremium()">
        <p *ngIf="showMessageBtnSideDrawer">
          <i class="fa fa-envelope-o"></i>
          <a (click)="openMessageDrawer($event, currentContactId, currentRfqid)">Message Buyer</a>
        </p>
        <p *ngIf="showPhoneNoSideDrawer" style="color:black;cursor: normal;">{{iContactViewModel.phoneNo}}</p>
        <p *ngIf="showEmailSideDrawer" ><a href="mailto:{{iContactViewModel.emailId}}" style="padding-left:0px;">{{iContactViewModel.emailId}}</a>
        </p>
        <p style="color:black;cursor: normal;">
          <span class="f-w-600">Preferred Method of communication:</span> <br />
          {{iContactViewModel.preferredMethodOfCommunication}}</p>

        <p style="color:black;cursor: normal;"
          *ngIf="iContactViewModel.companyFeedbacks !=null && iContactViewModel.companyFeedbacks !=''">
          <span class="f-w-600">Buyer Feedback:</span> <br />
          {{iContactViewModel.companyFeedbacks |Na}}</p>
      </div>
      <div *ngIf="isPremium()" class="block_border"></div>
    </div>
    <div class="col-md-12 ">
      <div class="mainheading"> Types of RFQ’s Sourced </div> <br>
    <app-rfq-sourced-type [buyerContactId]="iContactViewModel.contactId"></app-rfq-sourced-type>
    <div  class="block_border"></div>
    </div>

    <div class="col-md-12 rightpanel m-t-10">
      <div class="mainheading"> Demographics </div>
      <div *ngIf="iAboutUsModel?.createdDate !== null">
        <div class="sub_heading">
          <strong>Industry:</strong><br />
          <label
            *ngIf="iAboutUsModel.supplierType !== null">{{ iAboutUsModel?.supplierType.supplierTypeNameEn}}</label>
        </div>
        <div class="sub_heading">
          <strong># of Employees:</strong><br />{{ iAboutUsModel?.employeeCountRange }}
        </div>
        <div class="sub_heading"><strong>Languages:</strong><br />
          <div *ngIf="iAboutUsModel?.languages?.length === 0"> N/A </div>
          <div *ngFor="let language of iAboutUsModel?.languages"> {{ language?.languageName}} </div>
        </div>
        <div class="sub_heading" *ngIf="isPremium()"><strong>D-U-N-S Number:</strong><br />
          <div>{{ iAboutUsModel?.dunsNumber}} </div>
          <div *ngIf='iAboutUsModel.dunsNumber === ""'> N/A </div>
        </div>
        <div class="sub_heading" title="{{ iAboutUsModel.cageCode}}" *ngIf="isPremium()"><strong>Cage
            Code:</strong><br />{{ iAboutUsModel?.cageCode | dotLimit:'35'}}</div>
      </div>
      <div class="block_border"></div>
    </div>
    <div class="col-md-12 rightpanel" *ngIf="isPremium()">
      <div class="mainheading"> Company Description </div>
      <div class="company_desc descP" *ngIf="iAboutUsModel.description !== ''">
        <p class="description-wraper" [innerHTML]="iAboutUsModel.description | sanitizeNolimit"> </p>
        <a *ngIf="showViewFullProfileSideDrawer" (click)="readMore(iContactViewModel.companyId);" style="font-size: 14px">View Profile</a>
      </div>
      <div class="company_desc" *ngIf="iAboutUsModel.description == ''">
        <p>No company description at this time.</p>
        <a *ngIf="showViewFullProfileSideDrawer" (click)="readMore(iContactViewModel.companyId);" style="font-size: 14px">View Profile</a>
      </div>
      <div class="block_border"></div>

    </div>
    <div *ngIf="!isPremium() && showViewFullProfileSideDrawer">
      <button class="Rectangle-2" type="button">
        <span class="button-lbl" (click)="readMore(iContactViewModel.companyId);">View Full Profile</span>
      </button>
    </div>
  </div>
</div>
<app-buyer-feedback-model [companyName]="companyName" [companyId]="companyId" *ngIf="showFeedbackModel"
  (modelCloseChange)="showFeedbackModel = $event" (modelChangeReload)="reloadProfile($event)">
</app-buyer-feedback-model>